import http from '../../utils/http';
import { isEmpty } from 'lodash';

const getRecords = async (values) => {
	const { page, pageSize, filter, searchAdditionalQueryParams, options } =
		values;

	// Filter out empty filter values
	const filteredParams = filter && typeof filter === 'object' 
		? Object.keys(filter).reduce((acc, key) => {
				if (filter[key] !== '') acc[key] = filter[key];
				return acc;
			}, {})
		: {};

	// Handle search string from options
	const searchParams = {};
	if (options && options.filter && typeof options.filter === 'string' && options.filter.trim() !== '') {
		searchParams.search = options.filter;
	}

	const finalParams = {
		pageOffset: page,
		pageSize,
		...filteredParams,
		...searchParams,
		...searchAdditionalQueryParams,
		...(values.orderBy && { orderBy: values.orderBy }),
		...(values.order && { order: values.order }),
		...(options && Object.keys(options).length && options),
	};

	return await http.get(finalParams, values.searchEndpont);
};

const onLoad = async ({ values }) => {
	const result = await getRecords(values);

	if (result.errored) {
		return {
			...result,
			isValid: false,
		};
	}
	let rowsOnMount = result.rows;

	rowsOnMount = rowsOnMount.slice(
		0 * values.pageSize,
		0 * values.pageSize + values.pageSize
	);

	const numEmptyRows =
		values.page > 0 ? Math.max(0, values.pageSize - result.rows.length) : 0;
	const newPaddingHeight = (values.dense ? 24 : 42) * numEmptyRows;

	return {
		...result,
		visibleRows: rowsOnMount,
		isValid: true,
		paddingHeight: newPaddingHeight,
	};
};

const onSubmit = async ({ values, onInvalidForm, onFail, onSuccess }) => {
	try {
		const errors = {};
		if (!isEmpty(errors)) return onInvalidForm(errors);

		const result = await getRecords(values);
		if (result.errored) return onFail(result.error);

		onSuccess({
			saved: true,
			rows: result.rows,
			totalCount: result.totalCount,
		});
	} catch (e) {
		return onFail(e.message);
	}
};

export { onLoad, onSubmit, getRecords };
